<template>
  <v-card elevation="0" tile>
    <!-- <pre>{{ v$ }}</pre> -->
    <form>
      <v-row class="">
        <v-col class="mt-4" cols="12" md="3">
          <h4> {{ $t('accountSettings.personalData.nameTitle') }} *</h4>
        </v-col>
        <v-col cols="12" md="9">
          <v-text-field class="" v-model="form.name" outlined required @input="v$.form.name.$touch()"
            @blur="v$.form.name.$touch()" :error-messages="nameErrors" counter="100"></v-text-field>
        </v-col>
      </v-row>
      <!-- <pre>{{ v$ }}</pre> -->

      <v-divider class="mb-6"></v-divider>
      <v-row>
        <v-col class="mt-2" cols="12" md="3">
          <h4>Email *</h4>
        </v-col>
        <v-col cols="12" md="9">
          <v-text-field disabled outlined v-model="form.email" label="E-mail" required @input="v$.form.email.$touch()"
            @blur="v$.form.email.$touch()" :error-messages="emailErrors"></v-text-field>
        </v-col>
      </v-row>
      <v-divider class="mb-6"></v-divider>
      <v-row>
        <v-col class="mt-2" cols="12" md="3">
          <h4>{{ $t('accountSettings.personalData.phoneTitle') }} *</h4>
        </v-col>
        <v-col cols="12" md="9" class="d-flex">
          <v-select class="--flag mr-2" :items="assets.countries" item-text="name" item-value="code" v-model="location"
            outlined>
            <template #append>
              <v-img max-width="22" max-height="22" style="margin: 4px 8px 0 -5px;" contain
                :src="require(`@/assets/flags/${currentCountry.flag}`)"></v-img>
            </template>
            <template v-slot:item="slotProps">
              <v-img max-width="22" max-height="22" class="mr-3" contain
                :src="require(`@/assets/flags/${slotProps.item.flag}`)"></v-img>
              {{ slotProps.item.name }}

            </template>

          </v-select>
          <template v-for="(c, i) in assets.countries">
            <div  :key="i">
              <v-text-field v-if="i == currentCountry.index" outlined v-model="form.phoneNumber" label="Telefone" @input="v$.form.phoneNumber.$touch()"
                @blur="v$.form.phoneNumber.$touch()" :error-messages="phoneErrors" v-mask="c.phoneMasks"
                :placeholder="currentCountry.phonePlaceholder"></v-text-field>
            </div>
          </template>
        </v-col>
      </v-row>
      <v-divider class="mb-6"></v-divider>
      <v-row>
        <v-col class="mt-2" cols="12" md="3">
          <h4>{{ $t('accountSettings.personalData.officeTitle') }}</h4>
        </v-col>
        <v-col cols="12" md="9">
          <v-text-field outlined v-model="form.jobDescription"></v-text-field>
        </v-col>
      </v-row>
      <v-divider class="mb-6"></v-divider>
      <v-row>
        <v-col class="mt-2" cols="12" md="3">
          <h4>{{ $t('account.whitelabel.data.usersManagement.accessLevel') }}</h4>
        </v-col>
        <v-col cols="12" md="9">
          <v-text-field outlined disabled v-model="type"></v-text-field>
        </v-col>
      </v-row>

      <v-divider class="mb-6"></v-divider>
      <v-row>
        <v-col class="mt-2" cols="12" md="3">
          <h4>{{ $t('accountSettings.personalData.timezone') }}</h4>
        </v-col>
        <v-col cols="12" md="9">
          <v-select outlined :items="timezones" item-text="text" item-value="value" v-model="form.timezone"></v-select>
        </v-col>
      </v-row>



      <v-row class="">
        <v-col cols="12" md="12" class="text-end">
          <v-btn :disabled="disabledBtn" color="success" large :loading="loading" @click="submit">
            {{ this.$t('common.save') }}
          </v-btn>
        </v-col>
      </v-row>
    </form>
    <!-- <v-snackbar style="top: 70px" top right v-model="success.show" color="green">

      <span v-html="success.text"></span>
      <v-btn icon @click="success.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar> -->
    <v-snackbar style="top: 70px" top right v-model="errors.show" color="red">
      <span v-html="errors.text"></span>
      <v-btn icon @click="errors.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-card>
</template>
<script>
//import UserName from "./UserName.vue";
import { mapActions } from 'vuex'

import moment from 'moment-timezone'
import useVuelidate from "@vuelidate/core";
import { required, minLength, maxLength, email } from "@vuelidate/validators";

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  name: "UserForm",
  components: {
    // UserName,
  },
  validations() {
    return {
      form: {
        name: { required, minLength: minLength(3), maxLength: maxLength(100) },
        email: { required, email },
        phoneNumber: { required, minLength: minLength(0) /*this.currentCountry.phoneMinLength)*/ },
      },
    };
  },
  data() {
    return {
      type: null,
      location: 'BRA',
      timezones: [
        {
          text: 'Berlin - Alemanha',
          value: 'Europe/Berlin'
        },
        {
          text: 'Cidade do México - Mexico',
          value: 'America/Mexico_City'
        },
        {
          text: 'Dubai - EAU',
          value: 'Asia/Dubai'
        },

        {
          text: 'Lima - Peru',
          value: 'America/Lima'
        },
        {
          text: 'Lisboa - Portugal',
          value: 'Europe/Lisbon'
        },
        {
          text: 'Londres - Inglaterra',
          value: 'Europe/London'
        },
        {
          text: 'Los Angeles - US',
          value: 'America/Los_Angeles'
        },
        {
          text: "Miami (Eastern) - US",
          value: 'US/Eastern'
        },
        {
          text: 'New York - US',
          value: 'America/New_York'
        },
        {
          text: 'Paris - França',
          value: 'Europe/Paris'
        },
        {
          text: 'Santiago - Chile',
          value: 'America/Santiago'
        },
        {
          text: 'São Paulo - Brasil',
          value: 'America/Sao_Paulo'
        },
        {
          text: 'Tokyo - Japan',
          value: 'Asia/Tokyo'
        }
      ],
      accessItems: ['Administrador', 'Analista', 'Usuário'],
      assets: {
        countries: [
          {
            name: 'Brasil',
            currency: 'BRL',
            code: 'BRA',
            flag: 'bra.svg',
            lang: 'es',
            phoneMasks: '+55 (##) ####-#####',
            phonePlaceholder: '+55 (00) 0000-0000',
            phoneMinLength: 18,
            index: 0,
            personalDocument: 'CPF',
            personalDocumentMask: '###.###.###-##',
            companyDocument: 'CNPJ',
            companyDocumentMask: '##.###.###/####-##',
            zipCodeMask: '#####-###'
          },

          {
            name: 'Chile',
            currency: 'CHI',
            code: 'CHI',
            flag: 'chi.svg',
            lang: 'es',
            phoneMasks: '+56 ## #-###-###',
            phonePlaceholder: '+56 00 0-000-000',
            phoneMinLength: 15,
            index: 1,
            personalDocument: 'RUN',
            personalDocumentMask: '##.###.###-#',
            companyDocument: 'RUT',
            companyDocumentMask: '##.###.###-#',
            zipCodeMask: '### ####'
          },
          {
            name: 'Colombia',
            currency: 'COL',
            code: 'COL',
            flag: 'col.svg',
            lang: 'es',
            phoneMasks: '+57 ##-########',
            phonePlaceholder: '+57 00-0000000',
            phoneMinLength: 15,
            index: 2,
            personalDocument: 'RUT',
            personalDocumentMask: '##.###.###-#',
            companyDocument: 'NIT',
            companyDocumentMask: '##.###.###-#',
            zipCodeMask: '######'
          },

          {
            name: 'Mexico',
            currency: 'MEX',
            code: 'MEX',
            flag: 'mex.svg',
            lang: 'es',
            phoneMasks: '+52 ### #######',
            phonePlaceholder: '+52 000 0000000',
            phoneMinLength: 15,
            index: 3,
            personalDocument: 'CURP',
            personalDocumentMask: 'AAAA######AAAAAA##',
            companyDocument: 'RUT',
            companyDocumentMask: '##.###.###-#',
            zipCodeMask: '#####'
          },
          {
            name: 'Peru',
            currency: 'SOL',
            code: 'PER',
            flag: 'per.svg',
            lang: 'es',
            phoneMasks: '+51 ### ### ###',
            phonePlaceholder: '+51 000 000 000',
            phoneMinLength: 14,
            index: 4,
            personalDocument: 'DNI',
            personalDocumentMask: '########-#',
            companyDocument: 'RUC',
            companyDocumentMask: '###########',
            zipCodeMask: '#####'
          },

        ]
      },
      form: {
        name: "",
        email: "",
        phoneNumber: "",
        jobDescription: ""
      },


      loading: false,
      show: {
        old: false,
        new: false,
        confirm: false,
      },

      success: {
        text: "",
        show: false,
      },
      errors: {
        text: "",
        show: false,
      },
      errorsOldPassword: [],
    };
  },

  mounted() {
    const id = this.$root.auth.profile.profileAccessId
    const ids = [
      '',
      this.$t('account.whitelabel.data.usersManagement.form.typeAccessItems.administrator'),
      '',
      this.$t('account.whitelabel.data.usersManagement.form.typeAccessItems.commercial'),
      this.$t('account.whitelabel.data.usersManagement.form.typeAccessItems.marketing'),
      this.$t('account.whitelabel.data.usersManagement.form.typeAccessItems.financial'),
      '',
      this.$t('account.whitelabel.data.usersManagement.form.typeAccessItems.legal'),
      '',
      this.$t('account.whitelabel.data.usersManagement.form.typeAccessItems.creative'),
      this.$t('account.whitelabel.data.usersManagement.form.typeAccessItems.opec'),
      '',
      this.$t('account.whitelabel.data.usersManagement.form.typeAccessItems.product')
    ]
    this.type = ids[id]

    const { name, email, jobDescription, phones, timezone } = this.$root.auth.user
    this.form.name = name
    this.form.email = email
    this.form.timezone = timezone ? timezone : 'America/Sao_Paulo'

    const phone = phones.length ? JSON.parse(JSON.stringify(phones[0].contact)) : ""
    // var res = phone.replace(/\D/g, "");

    // console.log('phone', res)
    // setTimeout(() => {

    this.form.phoneNumber = phone
    this.form.jobDescription = jobDescription
    setTimeout(() => {
      if (this.form.phoneNumber) {
        const first = `${this.form.phoneNumber[1]}${this.form.phoneNumber[2]}`;
        console.log('first', first)
        switch (first) {
          case '56': case 56: this.location = 'CHI'; break;
          case '57': case 57: this.location = 'COL'; break;
          case '52': case 52: this.location = 'MEX'; break;
          case '51': case 51: this.location = 'PER'; break;
          case '55': case 55: default: this.location = 'BRA'; break;

        }
      }
    }, 1000)
    // },1000)

  },

  computed: {

    currentCountry() {
      return this.assets.countries.find(country => country.code == this.location)
    },
    disabledBtn() {
      return false
      return this.v$.$anyDirty && this.v$.$invalid
    },
    // phoneMask() {
    //   const result = this.currentCountry.phoneMasks;
    //   return result;
    // },

    nameErrors() {
      const errors = [];
      if (!this.v$.form.name.$dirty) return errors;
      this.v$.form.name.minLength.$invalid &&
        errors.push(this.$t("accountSettings.personalData.err.minLengthName", { count: 3 }));
      this.v$.form.name.maxLength.$invalid &&
        errors.push(this.$t("accountSettings.personalData.err.maxLengthName", { count: 100 }));
      this.v$.form.name.required.$invalid &&
        errors.push(this.$t('accountSettings.personalData.err.name'))
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.v$.form.email.$dirty) return errors;
      this.v$.form.email.$invalid &&
        errors.push(this.$t("accountSettings.personalData.err.email"));
      this.v$.form.email.required.$invalid &&
        errors.push(this.$t("accountSettings.personalData.err.requiredEmail"));
      return errors;
    },

    phoneErrors() {
      const errors = [];
      if (!this.v$.form.phoneNumber.$dirty) return errors;
      this.v$.form.phoneNumber.required.$invalid &&
        errors.push(this.$t("accountSettings.personalData.err.requiredPhone"));
        this.v$.form.phoneNumber.minLength.$invalid && errors.push(this.$t("accountSettings.personalData.err.minLengthPhone"));

      return errors;
    },

    // user() {

    //   if (!this.$root.auth.user)
    //     return {
    //       uid: null,
    //       email: "",
    //       name: "",
    //       show: false,
    //     };
    //   const { uid, email, name } = this.$root.auth.user;
    //   return {
    //     uid: uid,
    //     email: email,
    //     name: name,
    //     show: false,
    //   };
    // },

  },
  watch: {

  },
  methods: {


    ...mapActions("snackbar", ["showSnack"]),

    clear() {
      this.v$.$reset();
      this.name = "";
      this.email = "";
      this.select = null;
      this.checkbox = false;
    },

    showSave() {
      this.success.text = $t(
        "accountSettings.personalData.success.save"
      );
      this.success.show = true;
    },
    showError(e) {
      this.errors.text = e;
      this.errors.show = true;
    },


    submit() {
      const headers = this.$root.authToken
      let form = {
        name: this.form.name,
        id: this.$root.auth.user.uid,
        email: this.form.email,
        phoneNumber: this.form.phoneNumber,
        jobDescription: this.form.jobDescription,
        timezone: this.form.timezone
      };
      moment.tz.setDefault(this.form.timezone);
      this.v$.$touch()
      if (!this.v$.$invalid) {
        this.loading = true;
        this.$axios
          .put(`users`, form, {
            headers,
          })
          .then(
            () => {
              const contactForm = {
                name: this.form.name,
                contact: this.form.phoneNumber,
                contactTypeId: 2,
                set: 'user'
              }
              if (this.$root.auth.user.phones.length && this.$root.auth.user.phones[0] && this.$root.auth.user.phones[0].id) {
                this.$axios.put(`contacts/${this.$root.auth.user.phones[0].id}`, contactForm).then((contact) => {

                  const auth = JSON.parse(JSON.stringify(this.$root.auth))
                  auth.user.name = this.form.name;
                  auth.user.jobDescription = this.form.jobDescription
                  auth.user.timezone = this.form.timezone
                  auth.user.phones = [{ contact: this.form.phoneNumber, id: contact.data.data.id }];
                  localStorage.setItem("auth", JSON.stringify(auth));
                  this.showSnack({
                    text: this.$t('accountSettings.personalData.success.save'),
                    color: "success",
                    timeout: 4000,
                    icon: "mdi-check",
                  });
                  // this.success.text = this.$t("accountSettings.personalData.success.save");
                  // this.success.show = true;
                  this.loading = false;
                  //this.$root.auth.user.name = this.form.name;

                }, (err) => {
                  console.log('ERR', err)
                })
              }
              else {
                this.$axios.post(`contacts`, contactForm).then((contact) => {

                  const user = JSON.parse(JSON.stringify(this.$root.auth))
                  user.user.name = this.form.name;
                  user.user.timezone = this.form.timezone
                  user.user.phones = [{ contact: this.form.phoneNumber, id: contact.data.data.id }];
                  localStorage.setItem("auth", JSON.stringify(user));
                  this.showSnack({
                    text: this.$t('accountSettings.personalData.success.save'),
                    color: "success",
                    timeout: 4000,
                    icon: "mdi-check",
                  });
                  // this.success.text = this.$t("accountSettings.personalData.success.save");
                  // this.success.show = true;
                  this.loading = false;
                  //this.$root.auth.user.name = this.form.name;

                }, (err) => {
                  console.log('ERR', err)
                })
              }
            },
            (err) => {
              console.log(
                "err.response.data.errors[0].password[0]",
                err.response.data.errors[0].password[0]
              );
              this.loading = false;
              this.$emit("error", err.response.data.errors[0])
            }
          );

      }
    },
  },
};
</script>
<style lang="scss">
.--flag {
  flex: 0 0 60px !important;
  max-width: 60px !important;

  .v-select__selection.v-select__selection--comma {
    display: none !important;

  }

}
</style>